"use client";

import { useEffect } from "react";
import { CONSENT_EVENT, getConsent, trackViewContent } from "../../lib/meta-pixel";

/**
 * Sends Meta ViewContent for a product page. Fires once per product, either on
 * mount (consent already given) or the moment the shopper accepts on this page.
 */
export default function TrackViewContent(props: { id: string; name: string; price: number | null }) {
  const { id, name, price } = props;
  useEffect(() => {
    let sent = false;
    const send = () => {
      if (sent || getConsent() !== "granted") return;
      sent = true;
      trackViewContent({ id, name, price });
    };
    send();
    window.addEventListener(CONSENT_EVENT, send);
    return () => window.removeEventListener(CONSENT_EVENT, send);
  }, [id, name, price]);
  return null;
}
